import { Store } from 'rxjs-observable-store';
import { MainLayoutStoreState } from './main.layout.store.state';
import { Injectable } from '@angular/core';

@Injectable()
export class MainLayoutStore extends Store<MainLayoutStoreState> {
  constructor() {
    super(new MainLayoutStoreState());
  }

  set windowWidth(width: number) {
    let deviceType = '';
    let verticalNavType = '';
    let verticalEffect = '';
    if (width >= 768 && width <= 1024) {
      deviceType = 'tablet';
      verticalNavType = 'offcanvas';
      verticalEffect = 'push';
    } else if (width < 768) {
      deviceType = 'mobile';
      verticalNavType = 'offcanvas';
      verticalEffect = 'overlay';
    } else {
      deviceType = 'desktop';
      verticalNavType = 'expanded';
      verticalEffect = 'shrink';
    }
    this.setState({
      ...this.state,
      layoutAttr: {
        ...this.state.layoutAttr,
        windowWidth: width,
        deviceType,
        verticalNavType,
        verticalEffect,
      },
    });
  }

  set verticalNavType(type: string) {
    this.setState({
      ...this.state,
      layoutAttr: { ...this.state.layoutAttr, verticalNavType: type },
    });
  }

  set toggleMenuTooltip(label: string) {
    this.setState({
      ...this.state,
      tooltipLabels: { ...this.state.tooltipLabels, toggleMenu: label },
    });
  }

  resetBreadcrumbs() {
    this.setState({ ...this.state, breadcrumbs: [] });
  }

  toggleIsMobileCollapsed() {
    const type = this.state.layoutAttr.isCollapsedMobile === 'yes-block' ? 'no-block' : 'yes-block';
    this.setState({
      ...this.state,
      layoutAttr: { ...this.state.layoutAttr, isCollapsedMobile: type },
    });
  }
  closeSubMenus() {
    if (document.querySelector('.pcoded-trigger') != null) {
      document.querySelector('.pcoded-trigger').classList.remove('pcoded-trigger');
    }
  }
}
